import { Container, IconButton, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { Skeleton } from '@material-ui/lab'
import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import Button from '@/components/button'
import { useGetCogUrlFromDiagnosis } from '@/hooks/queries/use-get-cog-url-from-diagnosis'
import { useGetDiagnosisById } from '@/hooks/queries/use-get-diagnosis-by-id'
import { useGetPerimeterData } from '@/hooks/queries/use-get-perimeter-data'
import { useGetProjectByID } from '@/hooks/queries/use-get-project-by-id'
import DemandResume from '@/pages/demands/steps/resume/components/demand-resume'
import { getDemandAnalysisDecisionAnswer } from '@/services/demand-analysis-decision-answer'

import { DecisionModal } from '../../components/decision-modal'
import { Map } from '../../components/map'
import { useDemandAnalysisStore } from '../../contexts/demand-analysis-store-context'
import { useDemandAnalysisRoute } from '../../hooks/use-demand-analysis-route'
import { useStyles } from './styles'

export function Resume() {
  const classes = useStyles()
  const navigate = useNavigate()

  const [decisionModalOpen, setDecisionModalOpen] = useState(false)

  const { treatment, culture, diagnosisId, makeUrl } = useDemandAnalysisRoute()

  const { data: diagnosis } = useGetDiagnosisById(
    treatment!,
    culture!,
    diagnosisId,
  )

  const { data: projects } = useGetProjectByID(diagnosis?.project.id)
  const { data: perimeterData } = useGetPerimeterData(diagnosisId!)
  const { data: cogUrl } = useGetCogUrlFromDiagnosis(culture!, diagnosisId!)

  const { perimeterFromInput, mosaicFromInput } = useDemandAnalysisStore(
    (state) => ({
      perimeterFromInput: state.perimeter,
      mosaicFromInput: state.mosaic,
    }),
  )

  const perimeter = perimeterFromInput?.results.geojson || perimeterData
  const area =
    perimeterFromInput?.results.area || diagnosis?.perimeter.area || 0
  const imageSize = mosaicFromInput?.input.size
  const thumbnail = mosaicFromInput?.input

  // TODO: checking polygons

  function handleSubmit() {
    if (!perimeterFromInput?.edited) {
      const answer = getDemandAnalysisDecisionAnswer('substitution')

      if (!answer) return setDecisionModalOpen(true)
    }

    onSubmit()
  }

  function onSubmit() {
    navigate(makeUrl('upload'))
  }

  if (!perimeterFromInput && !mosaicFromInput) {
    return <Navigate to={makeUrl('info')} />
  }

  return (
    <Container className={classes.container}>
      <header className={classes.header}>
        <IconButton
          size='small'
          onClick={() => navigate(-1)}
          color='secondary'
          aria-label='Voltar'
        >
          <ArrowBack />
        </IconButton>

        <div>
          <Typography variant='h2'>Confirmar novos arquivos</Typography>
          <Typography variant='h5'>
            Analise os pontos de atenção do diagnóstico
          </Typography>
        </div>
      </header>

      <div className={classes.content}>
        <div className={classes.resume}>
          <Typography component={'span'}>Resumo do diagnóstico</Typography>

          <div>
            {!diagnosis ? (
              <Skeleton
                role='progressbar'
                width={'100%'}
                height={360}
                variant='rect'
                style={{ borderRadius: 4, transform: 'initial' }}
              />
            ) : (
              <DemandResume
                formData={{
                  area,
                  image_size: imageSize,
                  image_type: diagnosis!.imageType,
                  image_count: diagnosis!.imageCount || undefined,
                  culture: diagnosis!.culture,
                  treatment: diagnosis!.treatment,
                  project: diagnosis!.project.name,
                  region: projects?.regions.find(
                    (region) => region.id === diagnosis?.project.region_id,
                  )?.name!,
                  demand_name: diagnosis!.demandName,
                  flight_date: diagnosis!.flightDate,
                  sponsor: diagnosis!.username,
                }}
              />
            )}
          </div>
        </div>
        <div className={classes.map}>
          <Typography component={'span'}>Área cadastrada</Typography>

          <div>
            {!perimeterData || !(thumbnail || cogUrl) ? (
              <Skeleton
                role='progressbar'
                width={'100%'}
                height={'100%'}
                variant='rect'
                style={{ borderRadius: 4 }}
              />
            ) : (
              <Map
                perimeter={perimeter!}
                thumbnail={thumbnail}
                cogUrl={cogUrl}
              />
            )}
          </div>
        </div>
      </div>

      <footer className={classes.footer}>
        <Button outlined onClick={() => navigate(-1)}>
          Voltar
        </Button>
        <Button disabled={!diagnosis} onClick={handleSubmit}>
          Avançar
        </Button>
      </footer>

      <DecisionModal
        variant='substitution'
        open={decisionModalOpen}
        onClose={() => setDecisionModalOpen(false)}
        onSubmit={onSubmit}
      />
    </Container>
  )
}
